"use strict";

window.neptune.breadcrumbs = {
  instances: [],
  selectors: {
    breakpoint: ".plpc-bc",
    carousel: "[data-carousel-id]"
  },
  options: {
    contain: true,
    draggable: true,
    initialIndex: 0,
    pageDots: false,
    prevNextButtons: true,
    groupCells: true,
    cellAlign: "left"
  },
  init() {
    var bp = document.querySelector(this.selectors.breakpoint);
    if (!bp) {
      return;
    }
    var carousels = document.querySelectorAll(this.selectors.carousel);
    if (!carousels.length) {
      return;
    }
    if (bp.clientWidth > window.innerWidth || window.matchMedia("(max-width:700px)").matches) {
      this.create(carousels);
    } else {
      this.destroy();
    }
  },
  create(carousels) {
    carousels.forEach(el => {
      var exists = this.instances.some(x => x.el === el);
      if (exists) {
        return;
      }
      var id = el.getAttribute("data-carousel-id") || Math.floor(Math.random() * 9999);
      var slides = el.querySelectorAll(".carousel-cell").length;
      if (window["flickity"] != null) {
        var instance = new window.flickity(el, this.options);
        this.instances.push({
          el: el,
          instance: instance,
          id: id
        });
      }
    });
  },
  destroy() {
    if (!this.instances.length) {
      return;
    }
    this.instances.forEach(x => {
      if (x.instance && typeof x.instance.destroy === "function") {
        x.instance.destroy();
      }
    });
    this.instances = [];
  },
  resize() {
    this.init();
  }
};
window.addEventListener("load", () => {
  window.neptune.breadcrumbs.init();
});
window.addEventListener("resize", () => {
  window.neptune.breadcrumbs.resize();
});